import i18n from '../../../../i18n';
import { UkgDateFormat } from '../../../Enums/UkgDateFormat';
import  DateFormatService from "../../../services/DateFormatService"

const isValidDate = (dateValue) => {
    if (!dateValue || dateValue === 0 || dateValue === '0') {
        return false;
    }
    // Check if it's a valid date string (not epoch-era dates from 1969/1970)
    if (typeof dateValue === 'string') {
        const year = parseInt(dateValue.substring(0, 4), 10);
        return !isNaN(year) && year > 1970;
    }
    return false;
};

const displayDate = (target, workplan) => {
    // Use workplan period dates (startDate/endDate), not current status dates
    const dateField = target === 'effectiveDate' ? 'startDate' : 'endDate';
    const dateValue = workplan[dateField];
    if (!isValidDate(dateValue)) {
        return '';
    }
    if (dateValue === '3000-01-01') {
        return i18n.t('workplanManager:workPlanView.global.forever');
    }
    return DateFormatService.formatDateOrEmpty(dateValue, UkgDateFormat.LongDate);
};

export const formatWorkplans = (workplans) => workplans.map((fwp) => {
    return {
        displayEffectiveDate: displayDate('effectiveDate', fwp),
        displayEndDate: displayDate('endDate', fwp),
        ...fwp
    };
});